import styled from "styled-components";
import { orange20 } from "../../../config/colors";

export const OrangeLine = styled.div`
  position: relative;
  bottom: 0px;
  height: 10px;
  background-color: ${orange20};
  transition: width 200ms;
`;
